import { render, staticRenderFns } from "./Proto.vue?vue&type=template&id=5b0c9936&scoped=true&"
import script from "./Proto.vue?vue&type=script&lang=js&"
export * from "./Proto.vue?vue&type=script&lang=js&"
import style0 from "./Proto.vue?vue&type=style&index=0&id=5b0c9936&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c9936",
  null
  
)

export default component.exports